import Layout from  '@/layout'

// 首页
const dashRouter=
	{
		path:'/', //首页
		component:Layout,
		redirect: '/dashboard',
		hidden:false,
		children:[{
			path:'/dashboard',
			name:'dashboard',
			component:()=>import('@/views/dashboard/index.vue'),
			meta:{
				title:'首页',
				icon: 'el-icon-s-home',//图标
				affix: true, //是否固定
				requireAuth: true, 
			},
		}
		],
}
	
export default dashRouter
